import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { AuthService } from '../services';
import { UserProfileInterface, UserStoreInterface } from './types';

const initialUserState: UserProfileInterface = {
  userId: null,
  fullName: null,
  contact: null,
  emailId: null,
  roleName: null,
};

const UserStore = create<UserStoreInterface>()(
  persist(
    (set) => {
      return {
        isLoggedIn: AuthService.isLoggedIn(),
        entityCode: null,
        entityCodesList: null,
        userId: null,
        fullName: null,
        emailId: null,
        contact: null,
        roleName: null,
        setIsLoggedIn: (loggedIn) => {
          set(() => ({
            isLoggedIn: loggedIn,
          }));
        },

        setUserProfile: (profile) => {
          set((state) => {
            if (!profile) {
              return initialUserState;
            }
            const updatedState = { ...state } as any;
            const profileData: Array<keyof typeof profile> = [
              'userId',
              'fullName',
              'contact',
              'emailId',
              'roleName',
            ];

            for (const data of profileData) {
              if (profile[data] !== undefined) {
                updatedState[data] = profile[data];
              }
            }
            return updatedState;
          });
        },

        setEntityCode: (entityCode) => set({ entityCode }),
        setEntityCodesList: (entityCodesList) => set({ entityCodesList }),
      };
    },
    {
      name: 'user-store',
      partialize: (state) => ({
        entityCode: state.entityCode,
        entityCodesList: state.entityCodesList,
        userId: state.userId,
        emailId: state.emailId,
      }),
    }
  )
);

export default UserStore;
